module.exports = __webpack_public_path__ + "static/media/neumaticos.634a63c4.png";